import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getPromotions,
  updatePromotion,
} from "../../store/slice/PromotionSlice";
import { SidebarComponent } from "../../helpers/commonFunction";

const DeletePromotion = ({
  show,
  serviceDetail,
  handleClose,
  setDeleteModal,
  setDeleteModalId,
  page_number,
  values,
}) => {
  const dispatch = useDispatch();
  const showHideClassName = show && "user_detail_modal_show";
  const { t } = useTranslation("common");
  const sideHeading = localStorage.getItem("sidebar_component");

  const deletePromotionHandler = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updatePromotion({
        data,
        id: serviceDetail,
        isDelete: true,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(
              getPromotions({
                start: (page_number - 1) * 10,
                title: values.title,
                address: values.address,
                sub_title: values.sub_title,
              })
            );
            setDeleteModal(false);
            setDeleteModalId("");
          }
        },
        toast: t("toast.delete_promotion"),
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            Delete {SidebarComponent()}
            {/* {sideHeading} */}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.deletePromotionDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deletePromotionHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeletePromotion;
